import React from 'react';
import { Milestones } from '@insurancemenu/imenu-components-lib';
import { MilestoneItemType } from '@insurancemenu/imenu-components-lib/dist/types';
import { PAGE_SIDEBAR_TEST_IDS } from '../constants';
import {
  GroupSidebarStyled,
  GroupInfoSectionStyled,
  GroupTitleStyled,
  ViewProfileLinkStyled,
  InfoKeyStyled,
  InfoValueStyled,
  MilestonesStyled,
  DetailItemStyled,
  DetailsListStyled,
} from './styles';

export interface PageSidebarProps {
  groupName: string;
  infoMap: Record<string, string>;
  milestones: MilestoneItemType[];
  viewProfileText?: string;
  onViewProfileClick?: () => void;
}

const PageSidebar: React.FC<PageSidebarProps> = ({
  groupName,
  infoMap,
  milestones,
  viewProfileText,
  onViewProfileClick,
}) => {
  return (
    <GroupSidebarStyled data-test-id={PAGE_SIDEBAR_TEST_IDS.SIDEBAR}>
      <GroupInfoSectionStyled>
        <GroupTitleStyled data-test-id={PAGE_SIDEBAR_TEST_IDS.GROUP_TITLE}>{groupName}</GroupTitleStyled>
        {viewProfileText && onViewProfileClick && (
          <ViewProfileLinkStyled
            type="text"
            size="medium"
            onClick={onViewProfileClick}
            data-test-id={PAGE_SIDEBAR_TEST_IDS.VIEW_PROFILE_LINK}
          >
            ({viewProfileText})
          </ViewProfileLinkStyled>
        )}
        {Object.keys(infoMap).length > 0 && (
          <DetailsListStyled data-test-id={PAGE_SIDEBAR_TEST_IDS.DETAILS_LIST}>
            {Object.entries(infoMap).map(([label, value]) => (
              <DetailItemStyled key={label}>
                <InfoKeyStyled>{label}</InfoKeyStyled>
                <InfoValueStyled>{value}</InfoValueStyled>
              </DetailItemStyled>
            ))}
          </DetailsListStyled>
        )}
      </GroupInfoSectionStyled>
      <MilestonesStyled data-test-id={PAGE_SIDEBAR_TEST_IDS.MILESTONES_SECTION}>
        <Milestones milestones={milestones} allConnectingLinesWidth="4rem" />
      </MilestonesStyled>
    </GroupSidebarStyled>
  );
};

export default PageSidebar;
